const LIFE = 500;
const VERYSLOW = 1000;
const SLOW = 400;
const MEDIUM = 250;
const FAST = 100;

export { FAST, LIFE, MEDIUM, SLOW, VERYSLOW };

